module.exports = __webpack_public_path__ + "img/failure.9f41057f.svg";